import React, { createContext, useContext, useState } from "react";

/**
 * Sample Request Modal Context
 * Manages modal state and pre-filled data globally
 */
const SampleRequestContext = createContext({
  isOpen: false,
  openModal: () => {},
  closeModal: () => {},
  prefilledLots: [],
  source: ""
});

export const SampleRequestProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [prefilledLots, setPrefilledLots] = useState([]);
  const [source, setSource] = useState("");

  const openModal = (lots = [], sourceId = "") => {
    setPrefilledLots(lots);
    setSource(sourceId);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    // Clear data after modal closes
    setTimeout(() => {
      setPrefilledLots([]);
      setSource("");
    }, 300);
  };

  return (
    <SampleRequestContext.Provider
      value={{
        isOpen,
        openModal,
        closeModal,
        prefilledLots,
        source
      }}
    >
      {children}
    </SampleRequestContext.Provider>
  );
};

export const useSampleRequest = () => {
  const context = useContext(SampleRequestContext);
  if (!context) {
    throw new Error("useSampleRequest must be used within SampleRequestProvider");
  }
  return context;
};
